<template>
	<div class="main" style="min-height:700px;">
		<section class="panel">
			<header class="panel-heading">
				<h2 class="panel-title">宿舍物品借用申請表</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學&emsp;&emsp;號：</label>
						<div class="col-xs-9 col-md-7">{{model.account}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學&emsp;&emsp;制：</label>
						<div class="col-xs-9 col-md-7">{{model.deptSsymStr}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">性&emsp;&emsp;別：</label>
						<div class="col-xs-9 col-md-7">{{model.sexStr}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">姓&emsp;&emsp;名：</label>
						<div class="col-xs-9 col-md-7">{{model.name}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">科系班級：</label>
						<div class="col-xs-9 col-md-7">{{model.deptCodeStr}}-{{model.drade}}年{{model.dradeClass}}班</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">宿&emsp;&emsp;舍：</label>
						<div class="col-xs-9 col-md-7">{{model.bedFloor}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">聯絡電話：</label>
						<div class="col-xs-9 col-md-7">{{model.tel}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">行動電話：</label>
						<div class="col-xs-9 col-md-7">{{model.phone}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">寢&emsp;&emsp;室：</label>
						<div class="col-xs-9 col-md-7">{{model.bedRoom}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">常用信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.extMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學校信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.schMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">床&emsp;&emsp;位：</label>
						<div class="col-xs-9 col-md-7">{{model.bed}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">借用物品：</label>
						<div class="col-xs-9 col-md-7">
							<span v-if="isAdmin('stay') && resBorrom.applyStatus">{{resBorrom.resName}}</span>
							<select v-else class="form-control" v-model.number="resBorrom.resSno" v-validate="'required'" name="resSno" @change="onResChange">
								<option :value="null">--請選擇--</option>
								<option v-for="(resData, index) in resList" :key="index" :value="resData.sno">{{resData.name}}({{resData.remainder}})</option>
							</select>
							<span class="text-danger" v-show="errors.has('resSno')">{{ errors.first('resSno') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">數&emsp;&emsp;量：</label>
						<div class="col-xs-9 col-md-7">
							<span v-if="isAdmin('stay') && resBorrom.applyStatus">{{resBorrom.borrowNum}}</span>
							<select v-else class="form-control" v-model.number="resBorrom.borrowNum" v-validate="'required'" name="borrowNum">
								<option :value="null">--請選擇--</option>
								<option v-for="i in resTotal" :key="i" :value="i">{{i}}</option>
							</select>
							<span class="text-danger" v-show="errors.has('borrowNum')">{{ errors.first('borrowNum') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">預計歸還：</label>

						<div class="col-xs-9 col-md-7">
							<span v-if="isAdmin('stay') && resBorrom.applyStatus ">{{customFormatter(resBorrom.estimateDate)}}</span>
							<datepicker v-else :format="customFormatter" :language="zh" v-validate="'required'" :disabled-dates="state.disabledDates" input-class="form-control" 
								placeholder="預計歸還" :style="{width:'auto', display:'inline-block'}" v-model="resBorrom.estimateDate" name="estimateDate"/>
							<span class="text-danger" v-show="errors.has('estimateDate')">{{ errors.first('estimateDate') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="isAdmin('stay')">
					<div class="col-md-12 form-group">
						<label class="col-xs-12 col-md-u column-required">審核狀態：</label>
						<div class="radio-inline">
							<div v-if="model.applyStatus == 'A'">
								<label for="applyStatus_Y" class="radio-inline"> 
									<input id="applyStatus_Y" name="applyStatus" type="radio" value="Y" v-model="resBorrom.applyStatus" v-validate="'required|included:Y,N'"/> 借出
								</label>
								<label for="applyStatus_N" class="radio-inline"> 
									<input id="applyStatus_N" name="applyStatus" type="radio" value="N" v-model="resBorrom.applyStatus" /> 不借出
								</label>
								<span class="text-danger" v-show="errors.has('applyStatus')">{{ errors.first('applyStatus') }}</span>
							</div>
							<div v-else>{{resBorrom.applyStatusStr}}</div>
						</div>
						
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">借出日期：</label>
						<div class="col-xs-9 col-md-7" v-if="isAdmin('stay')">
							<datepicker :format="customFormatter" :language="zh" v-validate="'required'" :disabled-dates="borrowDateState.disabledDates" input-class="form-control" 
								 placeholder="借出日期" :style="{width:'auto', display:'inline-block'}" v-model="resBorrom.borrowDate" name="borrowDate"/>
							<span class="text-danger" v-show="errors.has('borrowDate')">{{ errors.first('borrowDate') }}</span>
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<span >{{customFormatter(resBorrom.borrowDate)}}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">歸還日期：</label>
						<div class="col-xs-9 col-md-7">
							{{resBorrom.escheatDate ? customFormatter(resBorrom.escheatDate) : ""}}
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="isAdmin('stay')">
					<div class="col-md-offset-4 col-md-2">
						<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
					</div>
					<div class="col-md-2">
						<a href="javascript:;" class="btn btn-primary btn-block" @click="checkResBorrow()">
							<span v-if="model.applyStatus == 'Y'">歸還</span>
							<span v-else>儲存</span>
						</a>
					</div>
				</div>
				<div class="row form-group" v-else-if="!model.applyStatus || model.applyStatus == 'A'">
					<div class="col-md-offset-2 col-md-2">
						<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
					</div>
					<div class="col-md-offset-1 col-md-2">
						<a href="javascript:;" class="btn s_btn_g btn-block" @click="clearFunc()">重填</a>
					</div>
					<div class="col-md-offset-1 col-md-2">
						<a href="javascript:;" class="btn btn-primary btn-block" @click="saveResBorrow()">儲存</a>
					</div>
				</div>
				<div class="row form-group" v-else>
					<div class="col-md-offset-5 col-md-2">
						<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	data(){
		return{
			model:{},
			resBorrom:{
				sno:null,
				applyId:"",
				resName:"",
				resSno:0,
				borrowNum:0,
				applyStatus:"",
				estimateDate:null,
				borrowDate:null,
				escheatDate:null,
				applyStatusStr:"",
			},
			resList:[],
			storeData:{},
			resRemainder:0,
			resTotal:0,
			state:{
				disabledDates:{
					to: this.toDate()
				}
			},
			borrowDateState:{
				disabledDates:{
					to: this.toDate()
				}
			}
		}
	},
	mounted(){
		this.init();
	},
	methods:{
		init(){
			this.$axios.post(`/api/ResBorrom/resList`).then(resp => {
				this.resList = resp.data.data
			});
			let param = {};
			if (this.getStore(this.$route.name) != null) {
				this.storeData = JSON.parse(this.getStore(this.$route.name));
				param = {
					sno:this.storeData.sno,
					account:this.storeData.account,
				}
			}else{
				param = {
					account:this.sessionData.account,
				}
			}
			const api = "/api/ResBorrom/editInit/";
			this.$axios.post(api, param).then(resp => {
				if(resp.data.status == "success"){
					this.model = resp.data.data;
					this.resBorrom = {
						sno: this.model.sno,
						account:this.model.account,
						applyId:this.model.applyId,
						resName:this.model.resName,
						resSno:this.model.resSno,
						borrowNum:this.model.borrowNum,
						applyStatus:this.model.applyStatus,
						estimateDate:this.model.estimateDate,
						borrowDate:this.model.borrowDate,
						escheatDate:this.model.escheatDate,
						applyStatusStr:this.model.applyStatusStr,
					};
				}else{
					bootbox.alert(resp.data.msg);
					this.$router.go(-1);
				}
			});
		},
		clickPrevious() {
			this.$router.go(-1)
		},
		clearFunc(){
			let keepSessionData = this.sessionData;
			Object.assign(this.$data, this.$options.data());
			this.sessionData = keepSessionData;
			this.state.disabledDates.to = this.nowDate();
			this.init();
		},
		saveResBorrow(){
			let _this = this;
			const api = "/api/ResBorrom/saveResBorromApply/";
			if(this.resRemainder >= this.resBorrom.borrowNum){
				this.$validator.validateAll().then(result => {
					if(result){
						let requestModel = {};
						for(let k in this.resBorrom){
							if(this.resBorrom[k]){
								if(k == "estimateDate" || k =="borrowDate"){
									requestModel[k] = this.customFormatter(this.resBorrom[k]);
								}else{
									requestModel[k] = this.resBorrom[k];
								}
							}
						}
						this.$axios.post(api, requestModel).then(resp =>{
							bootbox.alert(resp.data.msg, function(){
								if (resp.data.status === "success") {
									_this.$router.go(-1);
								}
							});
						});
					}else{
						bootbox.alert("請確認必填欄位是否有填寫");
					}
				});
			}else{
				bootbox.alert("物品數量不足");
			}
			
		},
		checkResBorrow(){
			this.$validator.validateAll().then(result =>{
				if(result){
					let _this = this;
					if(this.model.applyStatus === "Y"){
						this.resBorrom.applyStatus = "R";
					}
					this.resBorrom.borrowDate = this.customFormatter(this.resBorrom.borrowDate, "YYYY/MM/DD");
					const api = "/api/ResBorrom/checkResBorromApply/";
					this.$axios.post(api, this.resBorrom).then(resp =>{
						bootbox.alert(resp.data.msg, function(){
							if (resp.data.status === "success") {
								_this.$router.go(-1);
							}
						});
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		toDate(){
			let date = this.nowDate();
			date.setDate(date.getDate() -1);
			return date;
		},
		onResChange(){
			let tmpList = this.resList.filter(item =>{
				return item.sno == this.resBorrom.resSno;
			});
			if(tmpList.length > 0){
				this.resRemainder = tmpList[0].remainder;
				this.resTotal = tmpList[0].total;
			}
		}
	},
	watch:{
		
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>